import React, { useState, useEffect } from 'react';
import QRPassCreateDialog from './QRPassCreateDialog';
import QRPassDisplayDialog from './QRPassDisplayDialog';

const QRPassDialogsChain = ({ customer, onSuccess, isOpen, setIsOpen }) => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isDisplayOpen, setIsDisplayOpen] = useState(false);
  const [selectedQRPass, setSelectedQRPass] = useState(null);
  const [checkIn, setCheckIn] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setIsCreateOpen(true);
    }
  }, [isOpen, setIsOpen]);

  const handleCreateClose = () => {
    setIsCreateOpen(false);
    setSelectedQRPass(null);
    setIsOpen(false);
  };

  const handleDisplayClose = (createdQrPass) => {
    setIsDisplayOpen(false);
    onSuccess(createdQrPass);
    setIsOpen(false);
  };

  const handleCreate = (qrPass, checkIn) => {
    setSelectedQRPass(qrPass);
    setCheckIn(checkIn);
    setIsCreateOpen(false);
    setIsDisplayOpen(true);
  }

  return (
    <>
      {isCreateOpen && (
        <QRPassCreateDialog
            customer={customer}
            open={isCreateOpen}
            onCreate={handleCreate}
            onClose={handleCreateClose}
        />
      )}

      {isDisplayOpen && (
        <QRPassDisplayDialog
          customer={customer}
          qrCode={selectedQRPass}
          checkIn={checkIn}
          open={isDisplayOpen}
          onClose={handleDisplayClose}
          mode='create'
        />
      )}
    </>
  );
};

export default QRPassDialogsChain;
